import React, { Component, useState } from 'react';
import { useListingCompanies } from '../../hooks/useCompanies';
import { Modal, Button, Space, Select, Card } from 'antd';
import orderImage from '../../assets/images/orderImg.png';
import csvUpdates from '../../assets/images/csvUpdates.png';

import stc from 'string-to-color';

export default function SelectCompanyCode({ onCompanyCodeSelected, isCsvTool = false, title }) {
    const { data: companyCodeList } = useListingCompanies();
    const [companyCode, setCompanyCode] = useState(null);

    const oncompanyCodeChange = text => {
        setCompanyCode(text);
        onCompanyCodeSelected(text);
    };

    const heading = title || `Select a Client ${isCsvTool ? '' : 'For Planning'}`;

    return (
        <>
            <div
                style={{
                    width: '100%',
                    height: '80vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div className="addOrder-main w-100" style={{ marginTop: '60px' }}>
                    <Card className="newOrder_card mx-auto" style={{ maxWidth: 550 }}>
                        <h3>{heading}</h3>
                        <img
                            style={{
                                maxWidth: '100%',
                                height: 'auto',
                                border: '1px solid #00000014',
                            }}
                            src={isCsvTool ? csvUpdates : orderImage}
                            alt={csvUpdates ? 'csvUpdates' : 'orderImage'}
                        />
                        <Select
                            className="mt-2"
                            size="large"
                            style={{ width: '100%' }}
                            showSearch
                            placeholder="Select company code"
                            onChange={text => oncompanyCodeChange(text)}
                            value={companyCode}
                        >
                            {companyCodeList?.map(el => {
                                return (
                                    <Select.Option key={el._id} value={el.code}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'flex-start',
                                                alignItems: 'center',
                                                flexDirection: 'row',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    backgroundColor: stc(el.code),
                                                    width: '5px',
                                                    height: '15px',
                                                    marginRight: '5px',
                                                }}
                                            ></div>
                                            <span>{el.code}</span>
                                        </div>
                                    </Select.Option>
                                );
                            })}
                        </Select>
                    </Card>
                </div>
            </div>
        </>
    );
}
